module.exports = __webpack_public_path__ + "img/co2.082306d8.png";